import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const IS_MOBILE_APP_AVAILABLE: DiToken<boolean> = new DiToken<boolean>('isMobileAppAvailable', {
  factory: () => false
});
